import { Box, CircularProgress, IconButton, Menu, Paper, Slider, Stack, Typography, } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getResourceById, getTextItems } from "../request/get-resource-by-id";
import { BASE_PATH } from "../request/base";
import { FetchStatus } from "../request/model/fetch-status";
import { updateResource } from "../request/update-resource";
import { throttle } from "lodash";
import { Archive, ArrowBack, NextPlan, Pause, PlayArrow, Unarchive, } from "@mui/icons-material";
import { useTranslate } from "../use-translate";
const offset = 500; //milliseconds
const saveProgeress = (id, progress) => {
    localStorage.setItem(id, JSON.stringify({ time: progress }));
};
const restoreProgress = (id) => {
    const progress = localStorage.getItem(id);
    if (progress) {
        return JSON.parse(progress);
    }
    return { time: 0 };
};
export const Detail = () => {
    const { id } = useParams();
    const [resource, setResource] = React.useState(null);
    const [textItems, setTextItems] = React.useState([]);
    const [currentIndex, setCurrentIndex] = React.useState(-1);
    const [isPlaying, setIsPlaying] = React.useState(false);
    const [status, setStatus] = React.useState(FetchStatus.Idle);
    const [time, setTime] = React.useState(0);
    const isInited = React.useRef(false);
    const itemRefs = useRef([]);
    const { loading, error, result, translate } = useTranslate();
    const [position, setPosition] = React.useState(null);
    const navigate = useNavigate();
    const player = useMemo(() => {
        const audioPlayer = new Audio((resource === null || resource === void 0 ? void 0 : resource.audioUrl) || BASE_PATH + "/" + id + "/audio");
        audioPlayer.preload = "auto";
        audioPlayer.addEventListener("timeupdate", () => {
            const time = player.currentTime * 1000;
            setTime(time);
        });
        audioPlayer.addEventListener("play", () => {
            setIsPlaying(true);
        });
        audioPlayer.addEventListener("pause", () => {
            setIsPlaying(false);
        });
        audioPlayer.addEventListener("canplay", () => {
            if (isInited.current || !id) {
                return;
            }
            isInited.current = true;
            const progress = restoreProgress(id).time;
            audioPlayer.currentTime = progress / 1000;
            setTime(progress);
        });
        return audioPlayer;
    }, [id, resource === null || resource === void 0 ? void 0 : resource.audioUrl]);
    useEffect(() => {
        const contextMenuListener = (event) => {
            event.preventDefault();
            const selection = window.getSelection();
            if (selection) {
                const text = selection.toString();
                if (text) {
                    player.pause();
                    setPosition({ top: event.clientY + 10, left: event.clientX - 80 });
                    translate(text);
                    return;
                }
            }
        };
        document.addEventListener("contextmenu", contextMenuListener);
        return () => {
            document.removeEventListener("contextmenu", contextMenuListener);
        };
    }, []);
    useEffect(() => {
        return () => {
            player.pause();
            player.src = "";
        };
    }, [player, id]);
    useEffect(() => {
        if (!id) {
            return;
        }
        setStatus(FetchStatus.Fetching);
        getResourceById(id)
            .then((resource) => {
            setStatus(FetchStatus.Success);
            setResource(resource);
        })
            .catch(() => {
            setStatus(FetchStatus.Error);
        });
        getTextItems(id).then((items) => {
            setTextItems(items);
        });
    }, [id]);
    useEffect(() => {
        const index = textItems.findIndex((item) => item.offset <= time + offset &&
            item.offset + item.duration >= time + offset);
        if (index !== undefined && index !== -1) {
            setCurrentIndex(index);
        }
    }, [time, textItems]);
    useEffect(() => {
        if (currentIndex === -1) {
            return;
        }
        const element = itemRefs.current[currentIndex];
        console.log(element);
        if (element) {
            console.log("scrolling");
            element.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
    }, [currentIndex]);
    const throttledSaveProgress = useCallback(throttle(saveProgeress, 3000), []);
    useEffect(throttle(() => {
        if (!id || !isInited.current) {
            return;
        }
        throttledSaveProgress(id, time);
    }, 1000), [id, time, isInited.current]);
    const updateAudioTime = useCallback((index) => {
        player.pause();
        window.requestAnimationFrame(() => {
            player.currentTime = Math.max((textItems[index].offset - 500) / 1000, 0);
            window.requestAnimationFrame(() => {
                player.play();
            });
        });
        setCurrentIndex(index);
    }, [textItems]);
    const handlePlay = useCallback(() => {
        if (isPlaying) {
            player === null || player === void 0 ? void 0 : player.pause();
        }
        else {
            player === null || player === void 0 ? void 0 : player.play();
        }
    }, [isPlaying, player]);
    const goToLastSentence = useCallback(() => {
        if (!player) {
            return;
        }
        if (player.currentTime * 1000 - textItems[currentIndex].offset < 2000) {
            updateAudioTime(Math.max(currentIndex - 1, 0));
        }
        else {
            updateAudioTime(currentIndex);
        }
    }, [currentIndex, updateAudioTime, player, textItems]);
    const goToNextSentence = useCallback(() => {
        if (!player) {
            return;
        }
        updateAudioTime(Math.min(currentIndex + 1, textItems.length - 1));
    }, [currentIndex, updateAudioTime, player, textItems]);
    const onProgressChange = useCallback((_event, value) => {
        if (!player) {
            return;
        }
        player.currentTime = value / 1000;
    }, [player]);
    const handleArchive = useCallback(() => {
        if (resource && resource.id) {
            updateResource({ ...resource, isArchived: true }).then((newRes) => {
                setResource(newRes);
            });
        }
    }, [resource]);
    const handleUnarchive = useCallback(() => {
        if (resource && resource.id) {
            updateResource({ ...resource, isArchived: false }).then((newRes) => {
                setResource(newRes);
            });
        }
    }, [resource]);
    const handleBack = useCallback(() => {
        navigate("/");
    }, []);
    return (React.createElement(Stack, { spacing: 4, direction: "column", alignItems: "center", padding: 3, style: {
            flex: 1,
            overflow: "hidden",
            width: "90%",
            alignSelf: "center",
        } },
        status == FetchStatus.Success ? (React.createElement(React.Fragment, null,
            React.createElement(Paper, { elevation: 3, style: {
                    padding: "16px",
                    flex: 1,
                    overflow: "auto",
                    width: "100%",
                } },
                React.createElement(Stack, { direction: "column", spacing: 2 },
                    React.createElement(Typography, { variant: "h4" }, resource === null || resource === void 0 ? void 0 : resource.name),
                    textItems.map((item, index) => (React.createElement(Typography, { key: index, ref: (el) => (itemRefs.current[index] = el), onClick: () => updateAudioTime(index), sx: {
                            cursor: "pointer",
                            color: index === currentIndex ? "primary.main" : "text.primary",
                        } }, item.text))))),
            React.createElement(Stack, { direction: "row", spacing: 2 },
                React.createElement(IconButton, { onClick: goToLastSentence },
                    React.createElement(NextPlan, { sx: { transform: "rotate(180deg)" } })),
                React.createElement(IconButton, { onClick: handlePlay }, isPlaying ? React.createElement(Pause, null) : React.createElement(PlayArrow, null)),
                React.createElement(IconButton, { onClick: goToNextSentence },
                    React.createElement(NextPlan, null)),
                (resource === null || resource === void 0 ? void 0 : resource.isArchived) ? (React.createElement(IconButton, { onClick: handleUnarchive },
                    React.createElement(Unarchive, null))) : (React.createElement(IconButton, { onClick: handleArchive },
                    React.createElement(Archive, null))),
                React.createElement(IconButton, { onClick: handleBack },
                    React.createElement(ArrowBack, null))),
            React.createElement(Stack, { direction: "row", spacing: 1, width: "100%", alignItems: "center" },
                React.createElement(Box, { style: { flex: 1 } },
                    React.createElement(Slider, { value: time, max: (player.duration || 0) * 1000, onChange: onProgressChange })),
                React.createElement(Typography, { variant: "body2" }, new Date(time).toISOString().substr(11, 8) +
                    " / " +
                    new Date((player.duration || 0) * 1000)
                        .toISOString()
                        .substr(11, 8))))) : status === FetchStatus.Error ? (React.createElement(Typography, null, "Resource Not Found")) : status === FetchStatus.Fetching ? (React.createElement(CircularProgress, null)) : null,
        position && (React.createElement(Menu, { open: true, anchorReference: "anchorPosition", anchorPosition: position, onClose: () => {
                setPosition(null);
            } },
            React.createElement(Stack, { direction: "column", spacing: 2, padding: 2 },
                loading && React.createElement(CircularProgress, null),
                !loading && error && (React.createElement(Typography, { color: "error" }, error)),
                !loading && result && React.createElement(Typography, null, result))))));
};
